<div class="lock-policy-table">
  <div class="row"
    style="justify-content: space-between;  border: 2px solid #ccc;  padding-left: 4px; border-bottom: none;  background: white;">
    <utils-bar [search]="true"
      (searchValueSubmitted)="filter_string=$event;applyFilter.next(filter_string);"
      (searchCleared)="filter_string='';applyFilter.next(filter_string);">
    </utils-bar>
    <mat-paginator [length]="lockPolicyTableService.total"
      showFirstLastButtons
      style="justify-self: flex-end;">
    </mat-paginator>
  </div>

  <div class="table-container">
    <table [dataSource]="dataSource"
      [matSortActive]="'name'"
      (matSortChange)="updateSort($event)"
      class="table simple-table"
      mat-table matSort matSortDirection="asc">

      @for (column of columns; track column) {
        <ng-container [matColumnDef]="column">
          <th *matHeaderCellDef [mat-sort-header]="column" mat-header-cell>
            @if (column === 'edit') {
            }
            @if (column !== 'edit') {
              {{column | upperfirst | removeUnderscore}}
            }
          </th>
          <td *matCellDef="let policy;"
            mat-cell
            style="text-align: left;border:none;">
            @if (column === 'edit') {
              <i (click)="openDialog(policy)" class="fa fa-edit" style="cursor:pointer;"></i>
            }
            @if (column==='schedule') {
              {{getScheduleDescription(policy)}} UTC
            }
            @if (['created_on', 'changed_on', 'last_run_on'].includes(column)) {
              {{policy.attributes[column] | date:'medium':'UTC'}} UTC
            }
            @if (['name','enabled'].includes(column)) {
              {{policy.attributes[column]}}
            }
          </td>
        </ng-container>
      }

      <ng-container>
        <tr *matHeaderRowDef="columns; sticky: true" mat-header-row></tr>
        <tr *matRowDef="let row; columns: columns;" mat-row></tr>
      </ng-container>
    </table>
  </div>
</div>
